// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"80d19682","467":"d5926db4","588":"bbf8f494","602":"00ab5e41"}[chunkId] + ".chunk.css";
};